import { useMutation } from '@tanstack/react-query'

import * as api from '../api'
import useInvalidate from '../useInvalidate'

export default function useBookOnDemandCourse() {
  const invalidate = useInvalidate()

  return useMutation({
    mutationFn: async ({ courseUuid }: { courseUuid: string }) => {
      await api.post(`booking/on-demand-course/${courseUuid}`, {})
      await invalidate.userLearningAssignments()
    },
  })
}
